/**
 * Lightweight, render-time device checks based on the user agent.
 *
 * `isIphone` deliberately matches the iPhone only — *not* the iPad. Modern
 * iPads default to "desktop" Safari and report a macOS-style UA (no "iPad"
 * token), while the iPhone always carries "iPhone". Matching just "iPhone"
 * therefore leaves the iPad (and every desktop browser) untouched, which is
 * what we want: the Code Lens stays available everywhere except the phone,
 * where the Ace editor + Pyodide runtime are too cramped to be usable.
 */
export const isIphone = (): boolean =>
  typeof navigator !== "undefined" && /iPhone/i.test(navigator.userAgent);
